<template>
  <div>
    <!-- <div class="container-upload">
      <p>ลากวางหรือคลิกเพื่ออัพโหลดรูปภาพ</p>
      <input
        type="file"
        multiple
        ref="refInputUploadImages"
        accept="image/jpeg, image/png"
        @input="uploadImages($event)"
      />
    </div>
    <br /> -->
    <div v-for="image in wallpaperDatas.allImage" :key="image.localId">
      <b-card class="card-image-item" :class="validateDimensionImage(image)">
        <!-- <b-button variant="danger" class="btn-delete" size="sm" @click="removeImage(index, image)">
          ลบ
        </b-button> -->
        <b-badge
          v-if="
            $store.state.wallpapers.isHasOldData &&
              !image.tempIsHasOldDataFound &&
              $store.state.wallpapers.wallpaperDatas.statusType === 'checking'
          "
          variant="success"
          class="mb-1"
        >
          <feather-icon icon="StarIcon" class="mr-25" />
          <span>
            รูปเพิ่มมาใหม่
          </span>
        </b-badge>
        <b-row>
          <b-col sm="12" md="4">
            <div class="container-image-preview ct-cursor-zoom">
              <img alt="img-preview" class="image-preview" :src="image.file.previewUrl" @click="gZoomImage" />
            </div>
          </b-col>
          <b-col class="mt-sm-2 mt-md-0">
            <b-row>
              <b-col sm="12" md="4">
                <h5>
                  รายละเอียดรูปภาพ
                </h5>
                <ul>
                  <li>
                    {{ image.file.naturalWidth }}
                    <small class="text-muted">
                      width
                    </small>
                  </li>
                  <li>
                    {{ image.file.naturalHeight }}
                    <small class="text-muted">
                      height
                    </small>
                  </li>
                </ul>

                <h5 class="mb-0">
                  รายละเอียดการใช้ AI
                </h5>
                <div v-if="image.ai_generate_data">
                  <small>*เกณฑ์ที่กำหนดต้องใช้ AI ในการสร้างน้อยกว่า {{ image.ai_generate_data.threshold }}%</small>
                  <ul class="mt-50">
                    <li>AI สร้าง {{ image.ai_generate_data ? `${image.ai_generate_data.score}%` : '-' }}</li>
                    <li :class="[image.ai_generate_data.ai_generated ? 'text-danger' : 'text-success']">
                      {{ image.ai_generate_data.ai_generated ? 'ไม่อยู่ในเกณฑ์ที่กำหนด' : 'อยู่ในเกณฑ์ที่กำหนด' }}
                    </li>
                  </ul>
                </div>
                <div v-else class="mt-50 mb-1">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    size="sm"
                    block
                    @click="clickCheckImageGenerateAIDetails(image)"
                  >
                    แสดงรายละเอียด
                  </b-button>
                </div>
              </b-col>
              <b-col>
                <h5>
                  ตั้งค่ารายละเอียด
                </h5>
                <b-form>
                  <b-row>
                    <!-- name image -->
                    <b-col cols="12">
                      <b-form-group>
                        <label for="a-code">ชื่อรูปนี้</label>
                        <small v-if="translationTabKey === 'th'" class="text-danger"> *จำเป็นต้องระบุ</small>
                        <small v-else> (ถ้าไม่ระบุ จะแปลให้โดยอัตโนมัติ)</small>
                        <b-form-input
                          id="a-code"
                          v-model="image.options.title_translations[translationTabKey]"
                          type="text"
                          disabled
                        />
                      </b-form-group>

                      <div
                        v-if="
                          image.tempIsHasOldDataFound &&
                            isNewValueNotEqualOldValue(
                              image.options.title_translations[translationTabKey],
                              image.oldOptions.title_translations[translationTabKey],
                            )
                        "
                      >
                        <b-form-group>
                          <label>
                            <b-badge variant="danger">
                              ข้อมูลเดิม : ชื่อรูปนี้
                            </b-badge>
                          </label>
                          <b-form-input
                            v-model="image.oldOptions.title_translations[translationTabKey]"
                            type="text"
                            disabled
                          />
                        </b-form-group>
                        <hr />
                      </div>
                    </b-col>

                    <!-- detail image -->
                    <b-col cols="12">
                      <b-form-group>
                        <label for="b-code">รายละเอียดรูปนี้</label>
                        <small v-if="translationTabKey !== 'th'"> (ถ้าไม่ระบุ จะแปลให้โดยอัตโนมัติ)</small>
                        <b-form-textarea
                          id="b-code"
                          v-model="image.options.details_translations[translationTabKey]"
                          type="text"
                          rows="4"
                          disabled
                        />
                      </b-form-group>

                      <div
                        v-if="
                          image.tempIsHasOldDataFound &&
                            isNewValueNotEqualOldValue(
                              image.options.details_translations[translationTabKey],
                              image.oldOptions.details_translations[translationTabKey],
                            )
                        "
                      >
                        <b-form-group>
                          <label>
                            <b-badge variant="danger">
                              ข้อมูลเดิม : รายละเอียดรูปนี้
                            </b-badge>
                          </label>
                          <b-form-textarea
                            v-model="image.oldOptions.details_translations[translationTabKey]"
                            type="text"
                            rows="4"
                            disabled
                          />
                        </b-form-group>
                        <hr />
                      </div>
                    </b-col>

                    <!-- price image -->
                    <b-col cols="12">
                      <b-form-group>
                        <label for="c-code">ราคา</label>
                        <b-form-input
                          @keypress="isNumber($event)"
                          id="c-code"
                          v-model="image.options.price"
                          placeholder="ระบุราคารูป"
                          :disabled="true"
                        />

                        <small class="text-danger" v-if="wallpaperDatas.mainImage.revenue_sharing > 0">
                          ราคาหลักจากหักค่าบริการ {{ wallpaperDatas.mainImage.revenue_sharing }}%
                          <span v-if="wallpaperDatas.mainImage.affiliate.join_status">
                            + ค่าคอมมิชชั่น Affiliate {{ wallpaperDatas.mainImage.affiliate.commission_rate }}%
                          </span>
                          = จะได้รับ {{ calcPriceAfterTaxDisplay(image) }} บาท
                        </small>
                      </b-form-group>

                      <div
                        v-if="
                          image.tempIsHasOldDataFound &&
                            isNewValueNotEqualOldValue(image.options.price, image.oldOptions.price)
                        "
                      >
                        <b-form-group>
                          <label>
                            <b-badge variant="danger">
                              ข้อมูลเดิม : ราคา
                            </b-badge>
                          </label>
                          <b-form-input v-model="image.oldOptions.price" disabled />
                        </b-form-group>
                        <hr />
                      </div>
                    </b-col>

                    <!-- watermark image -->
                    <b-col cols="12">
                      <b-form-group label="สีลายน้ำ" label-for="d-code">
                        <b-form-radio-group
                          v-model="image.options.watermarkColor"
                          :options="optionsWatermarkColor"
                          name="d-code"
                          disabled
                        />
                      </b-form-group>
                      <div
                        v-if="
                          image.tempIsHasOldDataFound &&
                            isNewValueNotEqualOldValue(image.options.watermarkColor, image.oldOptions.watermarkColor)
                        "
                      >
                        <b-form-group>
                          <label>
                            <b-badge variant="danger">
                              ข้อมูลเดิม : สีลายน้ำ
                            </b-badge>
                          </label>
                          <b-form-radio-group
                            v-model="image.oldOptions.watermarkColor"
                            :options="optionsWatermarkColor"
                            disabled
                          />
                        </b-form-group>
                        <hr />
                      </div>
                    </b-col>

                    <!-- select day image -->
                    <b-col cols="12">
                      <b-form-group label="ผูกดวงประจำวัน (ไม่จำเป็น)" label-for="e-code">
                        <v-select
                          v-model="image.options.dayColor"
                          label="title"
                          :options="optionsDay"
                          :disabled="true"
                        />
                      </b-form-group>
                      <div
                        v-if="
                          image.tempIsHasOldDataFound &&
                            isNewValueNotEqualOldValue(image.options.dayColor, image.oldOptions.dayColor)
                        "
                      >
                        <b-form-group>
                          <label>
                            <b-badge variant="danger">
                              ข้อมูลเดิม : ผูกดวงประจำวัน
                            </b-badge>
                          </label>
                          <v-select
                            v-model="image.oldOptions.dayColor"
                            label="title"
                            :options="optionsDay"
                            :disabled="true"
                          />
                        </b-form-group>
                        <hr />
                      </div>
                    </b-col>

                    <!-- text color image -->
                    <b-col cols="12">
                      <b-form-group :label="`สีตัวอักษร (${image.options.fontColor})`" label-for="f-code">
                        <b-form-input id="c-code" type="color" v-model="image.options.fontColor" :disabled="true" />
                      </b-form-group>
                      <div
                        v-if="
                          image.tempIsHasOldDataFound &&
                            isNewValueNotEqualOldValue(image.options.fontColor, image.oldOptions.fontColor)
                        "
                      >
                        <b-form-group>
                          <label>
                            <b-badge variant="danger">
                              ข้อมูลเดิม : สีตัวอักษร ({{ image.oldOptions.fontColor }})
                            </b-badge>
                          </label>
                          <b-form-input type="color" v-model="image.oldOptions.fontColor" :disabled="true" />
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

export default {
  components: {
    ToastificationContent,
    vSelect,
  },
  props: {
    translationTabKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('AuthStore', ['_userInfo']),
    ...mapState('wallpapers', ['wallpaperDatas']),
    optionsDay() {
      return ['จันทร์', 'อังคาร', 'พุธ', 'พฤหัส', 'ศุกร์', 'เสาร์', 'อาทิตย์']
    },
    optionsWatermarkColor() {
      return [
        { text: 'ดำ', value: 'black' },
        { text: 'ขาว', value: 'white' },
      ]
    },
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    checkDimensionImage(imgUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = e => {
          // const { naturalWidth, naturalHeight } = e.path[0] // e.path บางบราวเซอร์ไม่มีทำให้แตก
          const { naturalWidth, naturalHeight } = img
          resolve({ naturalHeight, naturalWidth })
        }
        img.onerror = reject

        img.src = imgUrl
      })
    },
    uploadImages(event) {
      const filesObj = event.target.files
      Object.keys(filesObj).map(async val => {
        const file = filesObj[val]
        // console.log('file', file)
        const fileSize = Number(file.size / (1024 * 1024)).toFixed(2)
        // console.log('fileSize', fileSize)
        if (fileSize > 10) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'ขนาดรูปผิดพลาด',
              icon: 'BellIcon',
              text: 'ขนาดรูปที่ต้องการต้องไม่เกิน 10 mb',
              variant: 'danger',
            },
          })
          return
        }
        const previewUrl = URL.createObjectURL(file)
        file.previewUrl = previewUrl

        try {
          const dimension = await this.checkDimensionImage(previewUrl)

          file.naturalHeight = dimension.naturalHeight
          file.naturalWidth = dimension.naturalWidth
          const localId = uuidv4()
          file.localId = localId
          const newFile = {
            localId,
            file,
            options: {
              price: 0,
              fontColor: '#000',
              dayColor: null,
            },
          }
          this.wallpaperDatas.allImage = [...this.wallpaperDatas.allImage, newFile]
        } catch (e) {}
      })
      this.wallpaperDatas.mainImage.file = null
      this.$refs.refInputUploadImages.value = null
    },
    async removeImage(index, imageInfo) {
      if (imageInfo?.id) {
        await this.api.del('/api/admin/admin-topic-image-lists', imageInfo, true)
      }
      this.wallpaperDatas.mainImage.file = null
      this.wallpaperDatas.allImage.splice(index, 1)
    },
    validateDimensionImage(image) {
      const allImage = this.wallpaperDatas.allImage
      if (allImage.length <= 1) return ''
      const { naturalWidth, naturalHeight } = image.file
      const firstImage = allImage[0]
      if (naturalHeight !== firstImage.file.naturalHeight && naturalWidth !== firstImage.file.naturalWidth) {
        return 'error'
      }

      return ''
    },
    calcPriceAfterTaxDisplay(item) {
      const n = Number(item.options.price || 0)
      // console.log('_userInfo', this._userInfo)
      const { join_status, commission_rate } = this.wallpaperDatas.mainImage.affiliate

      // eslint-disable-next-line camelcase
      if (join_status && commission_rate > 0 && commission_rate <= 10) {
        // eslint-disable-next-line camelcase, no-underscore-dangle
        return this.gFormatNumberToCurrency(
          // eslint-disable-next-line camelcase
          n - n * (this.wallpaperDatas.mainImage.revenue_sharing / 100) - n * (commission_rate / 100),
        )
      }

      // eslint-disable-next-line no-underscore-dangle
      return this.gFormatNumberToCurrency(n - n * (this.wallpaperDatas.mainImage.revenue_sharing / 100))
    },
    async clickCheckImageGenerateAIDetails(values) {
      this.gDisplayToast(
        'ตอนนี้ระบบตรวจเช็ค AI ไม่สามารถทำงานได้',
        'ข้อมูลเกี่ยวกับ AI ที่ได้อาจจะไม่ตรงตามความเป็นจริง',
        'danger',
      )
      return
      // console.log('clickCheckImageGenerateAIDetails', values)
      try {
        this.gOpenPageLoading()
        // 'https://lzd-img-global.slatic.net/g/ot/homepage/2f1fe0849742ab075583b45a6f10280a.jpeg_720x720q80.jpg_.webp'
        const urlForCreateFile = values.file.previewUrl
        const resp = await fetch(urlForCreateFile, { method: 'GET' })
        const blob = await resp.blob()
        const file = new File([blob], `${values.id}.jpg`, { type: blob.type })
        // console.log('file', file)

        const aiData = await this.gCheckImageGenerateAI(file)
        // console.log('clickCheckImageGenerateAIDetails', aiData)

        if (aiData && typeof aiData === 'object') {
          this.wallpaperDatas.allImage = [...this.wallpaperDatas.allImage].map(v => {
            if (v.id === values.id) {
              return { ...v, ai_generate_data: aiData }
            }

            return v
          })
        } else {
          this.gDisplayToast('พบข้อผิดพลาดเกี่ยวกับการเช็ค AI', 'โปรดลองใหม่อีกครั้ง', 'danger')
        }
      } catch (error) {
        this.gDisplayToast('พบข้อผิดพลาดเกี่ยวกับการเช็ค AI', 'โปรดลองใหม่อีกครั้ง', 'danger')
      } finally {
        this.gClosePageLoading()
      }
    },
    isNewValueNotEqualOldValue(newValue, oldValue) {
      return newValue !== oldValue
    },
  },
}
</script>

<style lang="scss" scoped>
img {
  height: 100%;
  object-fit: scale-down;
}

.container-upload {
  width: 100%;
  height: 100px;
  background-color: whitesmoke;
  border-radius: 0.5rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed rgb(187, 185, 185);
  cursor: pointer;
  p {
    margin: 0;
  }
  input {
    width: 100%;
    height: 100%;
    border: 1px solid red;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }
}

.card-image-item {
  position: relative;
  &.error {
    border: 1px solid red;
  }
  .btn-delete {
    position: absolute;
    top: -10px;
    right: -5px;
    padding: 0.5rem;
    z-index: 2;
  }
  .container-image-preview {
    width: 100%;
    height: 200px;
    overflow: hidden;
    background-color: #47526f;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
